// Joylashuv id → yozuv xaritasi, bir marta so'raladi va keshda turadi.
//
// NEGA ALOHIDA HOOK: joylashuv nomi kamida uch joyda kerak — NAS kartochkasi,
// jihozlar ro'yxati va shakllardagi tanlov. Har biri o'zi so'rasa bir xil
// ro'yxat uch marta yuklanardi; TanStack Query kaliti bitta bo'lgani uchun
// esa so'rov haqiqatda BITTA bo'ladi.

import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/api/queryKeys'
import { usePermissions } from '@/shared/auth/usePermissions'
import { fetchSiteIndex, type SiteEntry } from './sitesApi'

export interface SiteIndexApi {
  sites: readonly SiteEntry[]
  /** id → yozuv. `undefined` = shu id reyestrda topilmadi */
  byId: ReadonlyMap<string, SiteEntry>
  loading: boolean
  /**
   * Xarita ISHONCHLIMI — ya'ni "topilmadi" degan xulosa chiqarish mumkinmi.
   *
   * ⚠️ Bu maydon shuning uchun bor: xarita bo'sh bo'lishining uch sababi bor
   * va ular BIR XIL EMAS — hali yuklanmagan, `site.read` huquqi yo'q, yoki
   * reyestr chindan ham bo'sh. Faqat oxirgi holatda `noma'lum joylashuv`
   * ogohlantirishini ko'rsatish to'g'ri; qolganida u yolg'on ayblov bo'lardi.
   */
  reliable: boolean
}

export function useSiteIndex(): SiteIndexApi {
  const { can } = usePermissions()
  const allowed = can('site.read')

  const query = useQuery({
    queryKey: queryKeys.sites.index,
    queryFn: fetchSiteIndex,
    enabled: allowed,
    // Reyestr kunlab o'zgarmaydi — har sahifa almashganda qayta so'rash
    // keraksiz shovqin. O'zgartirilganda kesh ataylab bekor qilinadi.
    staleTime: 5 * 60_000,
  })

  const byId = useMemo(() => {
    const map = new Map<string, SiteEntry>()
    for (const site of query.data?.sites ?? []) map.set(site.id, site)
    return map
  }, [query.data])

  return {
    sites: query.data?.sites ?? [],
    byId,
    loading: allowed && query.isPending,
    // Ro'yxat chala kelgan bo'lsa (`truncated`) ham "topilmadi" xulosasi
    // noto'g'ri bo'ladi — o'sha yozuv shunchaki keyingi sahifada
    reliable: allowed && query.isSuccess && !query.data.truncated,
  }
}
